<template>
    <div class="dvgraficometasvendedores">
        <v-chart :options="options"/>
    </div>
</template>
<style>
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'

export default {
    name : "cmpgraficometasvendedores",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
		'series'
    ],
    data () {
        return {
            options : {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    show : false,
                    left: '0',
                    right: '0',
                    bottom: '0',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show  : false,
                            title : 'Salvar gráfico'                            
                        }
                    }
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    show : true,
                    data: []
                },
                series: [
                    {
                        name: 'Vendas',
                        type: 'bar',
                        data: []
                    },
                    {
                        name: 'Metas',
                        type: 'bar',
                        data: []
                    }
                ]
            }
        }
    },
    mounted: function () {         
    },    
    computed:{
    },
    watch:{
        series(){
            // this.options.title.text     			= this.titulo;
            this.options.yAxis.data 			 = this.agrupamento;
			this.options.series                  = this.series;
	
        }
    }    
}
</script>
<style>
    .dvgraficometasvendedores{
        margin-top: -15px;
    }
</style>